import { html } from 'lit';
const YoutubePanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.464 6.072c.295.31.508.697.617 1.12.627 2.658.482 6.855.012 9.616-.11.423-.322.81-.617 1.12s-.662.534-1.065.649C17.937 19 12.003 19 12.003 19s-5.935 0-7.41-.423a2.36 2.36 0 0 1-1.064-.649 2.55 2.55 0 0 1-.617-1.12c-.63-2.646-.458-6.846-.012-9.603.109-.424.322-.81.617-1.12s.662-.534 1.065-.65C6.056 5.014 11.99 5 11.99 5s5.934 0 7.408.423c.403.115.77.338 1.065.649M15 12l-5 3V9z" clip-rule="evenodd"/>
  </svg>
`;
export default YoutubePanel;
